exports.ALL = [
  {
    "Name": "Guard",
    "Daily Wage": "$8.40",
    "Monthly Wage": "$84.00",
    "Monthly Live-In Wage": "$63.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "1",
    "Armor": "light,medium",
    "Weapon": "one-hander,one-hander+shield,two-hander,melee",
    "Gear": "military",
  },
  {
    "Name": "Laborer",
    "Daily Wage": "$5.60",
    "Monthly Wage": "$56.00",
    "Monthly Live-In Wage": "$42.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "1",
    "Gear": "misc,strange",
  },
  {
    "Name": "Linkboy",
    "Daily Wage": "$4.20",
    "Monthly Wage": "$42.00",
    "Monthly Live-In Wage": "$31.50",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "1",
    "Gear": "adventure",
  },
  {
    "Name": "Ship Oarsman",
    "Daily Wage": "",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "$30.00",
    "Space": "",
    "Share": "20%",
    "Special": "",
    "Wealth": "1",
    "Gear": "misc,strange",
  },
  {
    "Name": "Servant",
    "Daily Wage": "$5.60",
    "Monthly Wage": "$56.00",
    "Monthly Live-In Wage": "$42.00",
    "Space": "10'",
    "Share": "",
    "Special": "",
    "Wealth": "1",
    "Gear": "misc,strange",
  },
  {
    "Name": "Slave",
    "Daily Wage": "$1.00",
    "Monthly Wage": "",
    "Monthly Live-In Wage": "",
    "Space": "5'",
    "Share": "",
    "Special": "slavery",
    "Wealth": "0",
    "Gear": "misc,strange",
  },
];


// WEBPACK FOOTER //
// ./src/data/unskilled-occupations.js